'use client';

import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import { useMemo } from 'react';
import { useServicePurchaseState } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import { KeyValueCard } from './key-value-card';
const facetsGridVariants = cva('bg-accent grid grid-cols-1 gap-2 px-3 py-3 lg:px-6 lg:py-4', {
  variants: {
    variant: {
      one: '',
      // 1 column always, we use the default styles only
      two: 'sm:grid-cols-2',
      three: 'sm:grid-cols-2 md:grid-cols-3 [&>*:nth-child(3)]:sm:col-span-2 [&>*:nth-child(3)]:md:col-span-1',
      fourOrMore: 'sm:grid-cols-2 md:grid-cols-4'
    }
  }
});
function SelectedFacets() {
  const $ = _c(7);
  const {
    facets
  } = useServicePurchaseState();
  let t0;
  bb0: {
    if (facets.length === 1) {
      t0 = "one";
      break bb0;
    }
    if (facets.length === 2) {
      t0 = "two";
      break bb0;
    }
    if (facets.length === 3) {
      t0 = "three";
      break bb0;
    }
    t0 = "fourOrMore";
  }
  const facetVariant = t0;
  let t1;
  if ($[0] !== facetVariant) {
    t1 = facetsGridVariants({
      variant: facetVariant
    });
    $[0] = facetVariant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== facets) {
    t2 = facets.map(_temp);
    $[2] = facets;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(facet) {
  return <KeyValueCard key={facet.originalFacet.id} label={facet.originalFacet.categoryLabel} value={facet.selectedOption} />;
}
export { SelectedFacets };